<template>
  <div class="post_meta" @click="openMetaLink($event)" v-if="metaData">
    <figure v-if="metaData.image" class="post-meta-image">
      <img :src="metaData.image" :alt="getImageUrl('placeholder_img.png')" />
    </figure>
    <div class="meta_body">
      <span v-if="metaData.siteName" class="title">{{
        metaData.siteName
      }}</span>
      <h6 v-if="metaData.title">{{ metaData.title }}</h6>
      <p v-if="metaData.description">{{ metaData.description }}</p>
    </div>
  </div>
</template>


<script lang="ts">
import utilService from "@/services/util.service";
import { defineComponent, onMounted, ref } from "vue";

export default defineComponent({
  props: ["meta"],
  components: {},
  setup(props) {
    const metaData = ref<any>();
    onMounted(() => {
      var meta = props.meta[props.meta.length - 1];
      metaData.value = utilService.getMetaDataObject(meta);
    });

    const openMetaLink = (event:any) => {
      event.stopPropagation();
      if (metaData.value.url) {
        window.open(metaData.value.url, "_blank");
      }
    };

    const getImageUrl = (url: string, directory: string | null) =>
      utilService.getImageUrl(url, directory);

    return {
      metaData,
      openMetaLink,
      getImageUrl,
    };
  },
});
</script>